import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "app-name" }, " Shop Planner ", -1)
const _hoisted_4 = { class: "app-menu" }
const _hoisted_5 = { class: "last-update" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lang_selector = _resolveComponent("lang-selector")!
  const _component_icon_inline = _resolveComponent("icon-inline")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_waiting_screen = _resolveComponent("waiting-screen")!
  const _component_icon_library = _resolveComponent("icon-library")!

  return (_ctx.isReady)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_lang_selector)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", null, [
            (_ctx.showManagement)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/tracking"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_inline, { icon: "fa-gauge-max" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.l.menu.trackingPanel), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showEmployee)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/employee"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_inline, { icon: "fa-user-helmet-safety" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.l.menu.operatorPanel), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showManagement)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: "/management"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_inline, { icon: "fa-ballot-check" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.l.menu.menuManagement.root), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showManagement)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  to: "/operations"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_inline, { icon: "fa-conveyor-belt-boxes" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.l.menu.menuOperations.root), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showPayroll)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  to: "/payroll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_inline, { icon: "fa-envelope-open-dollar" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.l.menu.menuPayroll.root), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showMembership)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  to: "/membership"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_inline, { icon: "fa-user-group" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.l.menu.menuMembership.root), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showAdministration)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 6,
                  to: "/configuration"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_inline, { icon: "fa-square-sliders" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.l.menu.configuration), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showManagement)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 7,
                  to: "/reporting"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_inline, { icon: "fa-file-chart-pie" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.l.menu.reporting), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showBackgroundTasks)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 8,
                  to: "/background-tasks"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_inline, { icon: "fa-bars-progress" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.l.menu.backgroundTasks), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showAdministration)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 9,
                  to: "/log"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_inline, { icon: "fa-list-timeline" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.l.menu.log), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.logout();})
            }, [
              _createVNode(_component_icon_inline, { icon: "fa-right-from-bracket" }),
              _createElementVNode("span", null, _toDisplayString(_ctx.l.menu.logout), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.l.shared.lastAppUpdate) + ":", 1),
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.lastUpdate), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["app-body", { authenticated: _ctx.auth.isAuthenticated }])
        }, [
          _createVNode(_component_router_view)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogs.dialogs, (d) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(d.component), {
            uniqueID: d.uniqueID,
            key: d.uniqueID
          }, null, 8, ["uniqueID"]))
        }), 128)),
        _createVNode(_component_waiting_screen),
        _createVNode(_component_icon_library)
      ], 64))
    : _createCommentVNode("", true)
}